/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, TemplateRef } from '@angular/core'
import { SessionCacheStatus } from '@helios/state-management'
import { CacheLoadListenerComponent } from './cache-load-listener.component'

/**
 * This is used in tests that depend on CacheLoadListenerComponent
 *
 * Note: this mock renders `content` unconditionally, so it deliberately does NOT
 * model the real component's cache-status or `notApplicable` gating. The render
 * contract for those lives in cache-load-listener.component.spec.ts; a panel spec
 * using this mock can only assert the inputs it binds.
 */
@Component({
  selector: 'hs-cache-load-listener',
  template: '<ng-template [ngTemplateOutlet]="content"></ng-template>',
})
export class MockCacheLoadListenerComponent
  implements Partial<CacheLoadListenerComponent>
{
  @Input() content: TemplateRef<any> | null = null
  @Input() sessionCacheStatus: SessionCacheStatus = SessionCacheStatus.UNKNOWN
  @Input() sessionId?: string
  @Input() accountIds?: number[]
  @Input() notApplicable = false
  @Input() notApplicableMessage?: string
}
